import { render, staticRenderFns } from "./GarageDoorDamageSeverity.vue?vue&type=template&id=41b0f40e&scoped=true"
import script from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./GarageDoorDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b0f40e",
  null
  
)

export default component.exports